export const queryKeys = {
  org_user: 'org_user',
  org_users: 'org_users',
  organization: 'organization',
  organizations: 'organizations',
  org_id: 'org_id',
  user: 'user',
  projects: 'projects',
  packages: 'packages',
  products: 'products',
  catalogAutocomplete: 'catalogAutocomplete',
  productsClosed: 'productsClosed',
  packageProducts: 'packageProducts',
  illustrations: 'illustrations',
  productVariants: 'productVariants',
  productVariantColors: 'productVariantColors',
  brandAnalysis: 'brandAnalysis',
  printTechniques: 'printTechniques',
  printTechniqueProducts: 'printTechniqueProducts',
  productPrice: 'productPrice',
  categories: 'categories',
  productsByCategory: 'productsByCategory',
  designs: 'designs',
  product_prices: 'product_prices',
  print_codes: 'print_codes',
  quotes: 'quotes',
  quoteItems: 'quoteItems',
  quoteItemsByOrg: 'quoteItemsByOrg',
  quoteItemById: 'quoteItemById',
  quoteSubItems: 'quoteSubItems',
  chats: 'chats',
  decorations: 'decorations',
  productDecorations: 'productDecorations',
  decorationSetupCost: 'decorationSetupCost',
  decorationUnitCost: 'decorationUnitCost',
  likes: 'likes',
  shippingLocations: 'shippingLocations',
  orders: 'orders',
  proofs: 'proofs',
  proofsByQuote: 'proofsByQuote',
  proofsByQuoteItem: 'proofsByQuoteItem',
  orderItems: 'orderItems',
  orderItemsByQuote: 'orderItemsByQuote',
  orderMessages: 'orderMessages',
  messages: 'messages',
  conversations: 'conversations',
  quoteShippingLocations: 'quoteShippingLocations',
  shipments: 'shipments',
  introductions: 'introductions',
  introduction: 'introduction',
  orgFavourites: 'orgFavourites',
  invoices: 'invoices',
  agentInstructions: 'agentInstructions',
  emailInbox: 'emailInbox',
  emailInboxInsights: 'emailInboxInsights',
  emailInboxStatus: 'emailInboxStatus',
  analyticsOverview: 'analyticsOverview',
  analyticsOrgs: 'analyticsOrgs',
  analyticsUsers: 'analyticsUsers',
  analyticsPages: 'analyticsPages',
  analyticsQuote: 'analyticsQuote',
  companyBrainDocs: 'companyBrainDocs',
  companyBrainSuggestions: 'companyBrainSuggestions',
  companyPulse: 'companyPulse',
  companyMilestones: 'companyMilestones',
}
